import type { GetUnitDetailsQuery } from '../../unit/unit.graphql.generated';
import {
  CurriculumFragment,
  CurriculumUnitFragment,
} from 'approot/shared/curriculum-tags/curriculum-tags.constants';
import { CURRICULUM_OPTIONS_EDIT, CurriculumOption } from 'global/constants';
import type { Pluck } from 'lib/gql/pluck';

export function removeDuplicateCurriculums(
  outcomes: CurriculumFragment
): Pluck<GetUnitDetailsQuery, 'getUnitById.outcomesByCurriculums'>[] {
  return outcomes.reduce<
    Pluck<GetUnitDetailsQuery, 'getUnitById.outcomesByCurriculums'>[]
  >((acc, outcome) => {
    const existingCurriculum = acc.find(
      c => c.curriculum === outcome.curriculum
    );

    if (!existingCurriculum) {
      acc.push({
        curriculum: outcome.curriculum,
      } as Pluck<GetUnitDetailsQuery, 'getUnitById.outcomesByCurriculums'>);
    }
    return acc;
  }, []);
}

export function hasAllCurriculums(outcomes: CurriculumUnitFragment) {
  const outcomesSet = new Set(outcomes.map(outcome => outcome.curriculum));

  const hasAllCurriculums = CURRICULUM_OPTIONS_EDIT.length === outcomesSet.size;

  return hasAllCurriculums;
}

export function formatSubjectCurriculums(curriculums: CurriculumOption[]) {
  return curriculums.map(
    curriculum =>
      ({
        curriculum,
      }) as Pluck<GetUnitDetailsQuery, 'getUnitById.outcomesByCurriculums'>
  );
}
